module.exports = __webpack_public_path__ + "static/media/loading.a21746f5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/loading.gif
// module id = 576
// module chunks = 0